/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Audit } from './audit';
import { User } from './identity';

export interface AuditLog extends Audit {
  auditors?: Array<User>;
  controls_count?: number;
  status?: StatusEnum;
  snapshot_id?: string;
}

export type StatusEnum = 'ACTIVE' | 'COMPLETED';
export const StatusEnum = {
  ACTIVE: 'ACTIVE' as StatusEnum,
  COMPLETED: 'COMPLETED' as StatusEnum
};
